/*************************************
 *
 * 全局函数
 *
 *************************************/

exports.install = (Vue, option) => {
  /**
   * 开启加载动画
   *
   * @param Vue
   */
  Vue.prototype.pageLoadingOpen = (Vue) => {
    Vue.$store.dispatch('common/setLoading', true)
  }

  /**
   * 关闭加载动画
   *
   * @param Vue
   */
  Vue.prototype.pageLoadingClose = (Vue) => {
    Vue.$store.dispatch('common/setLoading', false)
  }
}



// WEBPACK FOOTER //
// ./src/globalFunction.js